import React, { useContext, useEffect, useState } from "react";
import {
  ArchiveBoxIcon,
  Cog6ToothIcon,
  Bars4Icon,
  XMarkIcon,
  MapPinIcon,
  ArchiveBoxArrowDownIcon,
  ClipboardDocumentListIcon,
  ArrowRightEndOnRectangleIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import { useSelector, useDispatch } from "react-redux";

import Logo from "../../assets/images/logo.png";
import NavBarMenu from "./navBarMenu";
import CustomDropDownNavBar from "./customDropDownNavBar";
import LanguageToggleButton from "./languageSwitcherFlags";
import { useTranslation } from "react-i18next";
import CustomMenu from "./customMneu";
import NotificationButton from "./notificationList";
import NavBarMenuContactUsOurService from "./navContactUsOurService";
import { getAddressesByUserId } from "../../redux/reducer/userAddressReducer";
import { AuthContext } from "../auth/AuthContext";
import CustomDropDownNavBarCurrancy from "./customDropDownCurrancy";
import CartButton from "./CartButton";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import useLanguageDirection from "../../hooks/useLanguageDirection";
const Header = () => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1024);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const navigateWithLang = useLanguageNavigate();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn, logout } = useContext(AuthContext);
  const direction = useLanguageDirection();
  const { addresses, loading, error } = useSelector(
    (state) => state.userAddress
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
    document.documentElement.dir = savedLanguage === "ar" ? "ltr" : "rtl";
  }, [i18n]);

  const handleNavigation = () => {
    navigateWithLang("/contact-us", { replace: true });
    window.location.reload(); // Force reload after navigation
  };

  const logoStyle = {
    height: isMobile ? "48px" : "75px",
    padding: isMobile ? "4px 0px" : "10px 0",
  };

  const accessToken = localStorage.getItem("accessToken");
  useEffect(() => {
    if (accessToken) {
      dispatch(getAddressesByUserId());
    }
  }, [dispatch]);
  const handleClick = (e) => {
    e.preventDefault();
    navigateWithLang("/");
  };
  // console.log(direction);
  return (
    <div className="fixed top-0 left-0 z-50 w-full px-4 py-2 text-white bg-black shadow-md ">
      <div className="flex flex-row items-center justify-between max-container">
        {/* Icons Section */}
        <div className="flex items-center justify-center gap-2 md:gap-3">
          {/* Mobile Menu Button */}
          {isMobile && (
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? (
                <XMarkIcon className="w-6 h-6 text-white lg:w-7 lg:h-7" />
              ) : (
                <Bars4Icon className="w-6 h-6 text-white lg:w-7 lg:h-7" />
              )}
            </button>
          )}

          {/* Desktop */}
          <span className="hidden lg:flex">
            <CustomMenu addresses={addresses} />
          </span>
          {accessToken && (
            <NotificationButton notification={addresses?.notification} />
          )}
          {/* {accessToken && addresses?.user?.role === "customer" && (
            // role={addresses.}
            <CartButton role={addresses?.user?.role} />
          )} */}
          <div className="hidden lg:flex">
            <CustomDropDownNavBarCurrancy />
          </div>

          {/* Desktop & Mobile */}
          <div className="flex">
            <LanguageToggleButton
              desktop={true}
              language={addresses?.user?.language}
              accessToken={accessToken}
            />
          </div>
          {/* )} */}
        </div>

        {/* Navigation Menu */}
        <div
          className={` fixed top-12 left-0 z-[9999] w-full p-4 space-y-4 scroll-smooth bg-black items-center transition-all duration-300 ease-in-out transform
            ${
              menuOpen
                ? "opacity-100 translate-y-0 visible h-screen overflow-y-scroll"
                : "opacity-0 -translate-y-5 invisible"
            } 
            lg:static lg:w-auto lg:space-y-0 lg:space-x-6 lg:p-0 lg:opacity-100 lg:translate-y-0 lg:visible lg:flex`}
        >
          {/* Mobile */}
          <div className="block mt-3 border-b border-gray-800 lg:hidden">
            <ul className="">
              <li className="flex items-center justify-between mb-4 item">
                {isLoggedIn || accessToken ? (
                  <div
                    className="flex gap-2 text-red-400"
                    onClick={() => {
                      logout();
                      navigateWithLang("/");
                    }}
                  >
                    <ArrowRightEndOnRectangleIcon class="h-6 w-6 text-red-400" />
                    {t("logout")}
                  </div>
                ) : (
                  <div
                    className="flex gap-2 px-2 py-1 border-2 rounded-lg"
                    onClick={() => {
                      navigateWithLang("/login");
                    }}
                  >
                    {t("login")}
                  </div>
                )}
                <div className="">
                  <span>{t("welcome")} :</span>
                  {isLoggedIn || accessToken ? (
                    <>
                      <span> {addresses?.user?.firstName} </span>
                    </>
                  ) : (
                    <span> {t("visitor")} </span>
                  )}
                </div>
              </li>
              {(isLoggedIn || accessToken) && (
                <li className="flex justify-between mb-4" dir={direction}>
                  <div>
                    <span> {t("yourBoxNumber")} : </span>
                    <span> {addresses?.user?.boxNumber}</span>
                  </div>
                </li>
              )}
            </ul>
          </div>
          {(isLoggedIn || accessToken) && (
            <div className="block border-b border-gray-800 lg:hidden">
              <ul className="" dir={direction}>
                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/box-address");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <MapPinIcon class="h-5 w-5 text-white" />
                  {t("CartChooseButton")}
                </li>

                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/buy-for-me");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <ShoppingCartIcon class="h-5 w-5 text-white" />
                  {t("buy_for_me")}
                </li>

                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/my-orders");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <ClipboardDocumentListIcon class="h-5 w-5 text-white" />
                  {t("Company")}
                </li>

                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/my-orders");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <ArchiveBoxIcon class="h-5 w-5 text-white" />
                  {t("ListOfBoxCardOrders")}
                </li>

                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/my-shipments");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <ArchiveBoxArrowDownIcon class="h-5 w-5 text-white" />
                  {t("CustomOrders")}
                </li>

                <li
                  className="flex items-center gap-2 mb-4"
                  onClick={() => {
                    navigateWithLang("/my-account/finished-orders");
                    setMenuOpen(!menuOpen);
                  }}
                >
                  <XMarkIcon class="h-5 w-5 text-white" />
                  {t("FinishedOrders")}
                </li>
              </ul>
            </div>
          )}

          {/* Desktop & Mobile */}
          {isMobile ? (
            <>
              <NavBarMenu />
              <CustomDropDownNavBar language={i18n.language} />
              <NavBarMenuContactUsOurService role={addresses?.user?.role} />
            </>
          ) : (
            <>
              <NavBarMenuContactUsOurService role={addresses?.user?.role} />
              <CustomDropDownNavBar language={i18n.language} />
              <NavBarMenu />
            </>
          )}

          {/* Mobile */}
          <div className="block pt-4 border-t border-gray-800 lg:hidden pb-[100px]">
            <ul className="" dir={direction}>
              <li
                className="flex items-center gap-2 mb-4"
                onClick={() => {
                  navigateWithLang("/my-account");
                  setMenuOpen(!menuOpen);
                }}
              >
                <Cog6ToothIcon class="h-5 w-5 text-white" />
                {t("account_settings")}
              </li>
              <li className="mb-4 ">
                <CustomDropDownNavBarCurrancy isMobile={true} />
              </li>

              <li
                className="flex items-center gap-2"
                onClick={() => {
                  navigateWithLang("/contact-us");
                  setMenuOpen(!menuOpen);
                }}
              >
                {direction === "ltr" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-white"
                    height="28px"
                    viewBox="0 -960 960 960"
                    width="28px"
                    fill="white"
                  >
                    <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-white"
                    height="28px"
                    viewBox="0 -960 960 960"
                    width="28px"
                    fill="white"
                  >
                    <path d="M162-120q-18 0-30-12t-12-30v-162q0-13 9-23.5t23-14.5l138-28q14-2 28.5 2.5T342-374l94 94q38-22 72-48.5t65-57.5q33-32 60.5-66.5T681-524l-97-98q-8-8-11-19t-1-27l26-140q2-13 13-22.5t25-9.5h162q18 0 30 12t12 30q0 125-54.5 247T631-329Q531-229 409-174.5T162-120Zm556-480q17-39 26-79t14-81h-88l-18 94 66 66ZM360-244l-66-66-94 20v88q41-3 81-14t79-28Zm358-356ZM360-244Z" />
                  </svg>
                )}
                {t("contactUs")}
              </li>
            </ul>
          </div>
        </div>

        {/* Logo Section */}
        <div>
          <a
            href="/"
            // onClick={() => navigateWithLang("/")}
            onClick={handleClick}
          >
            <img src={Logo} alt="Logo" style={logoStyle} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
